const getSectionsRowClass = (record, index) => {
  return record.isRead ? '' : 'is-new';
};

export default getSectionsRowClass;